var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ChatIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M19 2H20C21.103 2 22 2.897 22 4V5V7V12C22 13.103 21.103 14 20 14V12V7.414V6C20 4.897 19.103 4 18 4H16.586H6C6 2.897 6.897 2 8 2H16.998H19ZM5 21.766V18H4C2.897 18 2 17.103 2 16V8C2 6.897 2.897 6 4 6H16C17.103 6 18 6.897 18 8V16C18 17.103 17.103 18 16 18H11.277L6.515 20.857L5 21.766ZM16 8H4V16H7V18.234L10.723 16H16V8Z" })))); };
export var Chat = styled(ChatIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=Chat.js.map